/**
 * "613798", "DOT 613798", "USDOT#613798". Mirrors parseDotNumberQuery on the
 * API, so the lookup the client chooses is the one the server would.
 */
const DOT_QUERY =
  /^(?:U\.?\s*S\.?\s*)?(?:D\.?\s*O\.?\s*T\.?)?\s*(?:#|NO\.?|NUMBER)?\s*:?\s*(\d{1,8})$/i

/** The DOT number in the query, or null when the query is not one. */
export const parseDotNumberQuery = (query: string): string | null => {
  const match = query.trim().match(DOT_QUERY)
  return match ? match[1] : null
}
